module.exports = __webpack_public_path__ + "static/media/slide04.babee68a.jpg";